(function () {
  /////// The Findstr search overlay (triggered by `.findstrOpenModal`) doesn't
  /////// return keyboard focus to its trigger on close: focus stays on an
  /////// element inside the now-hidden overlay, trapping Tab navigation there.
  /////// Restore focus to the trigger button whenever the overlay is closed.
  const TRIGGER_SELECTOR = '.findstrOpenModal';
  const CLOSE_SELECTOR = '.findstr-search-close-popup';
  const CONTAINER_SELECTOR = '.findstr-main-search-container';

  function restoreFocusToTrigger() {
    window.requestAnimationFrame(function () {
      const trigger = document.querySelector(TRIGGER_SELECTOR);
      if (trigger && trigger.ownerDocument.activeElement !== trigger) {
        trigger.focus();
      }
    });
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest(CLOSE_SELECTOR)) {
      restoreFocusToTrigger();
    }
  });

  document.addEventListener('keydown', function (event) {
    if ('Escape' !== event.key) {
      return;
    }

    const container = document.querySelector(CONTAINER_SELECTOR);
    if (
      container &&
      container.contains(container.ownerDocument.activeElement)
    ) {
      restoreFocusToTrigger();
    }
  });
})();
